import Vue from 'vue';
import * as types from '../mutation-types';
import UserNotificationSettings from '../../api/userNotificationSettings';

const state = {
  record: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getSelectedEmailFlags: $state => {
    return $state.record.selected_email_flags;
  },
  getSelectedPushFlags: $state => {
    return $state.record.selected_push_flags;
  },
  // ADR-0008 — preferência opt-in: push de criação de conversa restrito ao assignee.
  getAssignedConversationOnly: $state => {
    return $state.record.assigned_conversation_only;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, { isFetching: true });
    try {
      const response = await UserNotificationSettings.get();
      commit(types.default.SET_USER_NOTIFICATION, response.data);
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isFetching: false,
      });
    } catch (error) {
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  update: async (
    { commit, getters: $getters },
    { selectedPushFlags, assignedConversationOnly }
  ) => {
    commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, { isUpdating: true });
    try {
      // ADR-0009 — a coluna de e-mail foi removida da UI, mas o controller
      // atribui selected_email_flags incondicionalmente. Reenviamos o valor
      // atual do store (echo idempotente) para não zerar os flags no banco.
      const settings = {
        selected_email_flags: $getters.getSelectedEmailFlags || [],
        selected_push_flags: selectedPushFlags,
      };
      // ADR-0008 — só envia a preferência quando explicitamente fornecida.
      if (assignedConversationOnly !== undefined) {
        settings.assigned_conversation_only = assignedConversationOnly;
      }
      const response = await UserNotificationSettings.update({
        notification_settings: settings,
      });
      commit(types.default.SET_USER_NOTIFICATION, response.data);
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isUpdating: false,
      });
    } catch (error) {
      commit(types.default.SET_USER_NOTIFICATION_UI_FLAG, {
        isUpdating: false,
      });
      throw error;
    }
  },
};

export const mutations = {
  [types.default.SET_USER_NOTIFICATION_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_USER_NOTIFICATION]: ($state, data) => {
    Vue.set($state, 'record', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
